import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType, NbMassiveItem} from './nbinput.entity';


@Component({
  selector: 'nbinput-option',
  template: require('./nbinput-option.component.html'),
  styles: [require('./nbinput-option.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputOptionComponent),
      multi: true
    }
  ]
})

export class NbinputOptionComponent implements ControlValueAccessor {
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  multiple = false;
  @Input()
  set type(t: NbFieldType) {
    this.multiple = (t && t == NbFieldType.Multiple);
  }
  get type() {
    return this.multiple ? NbFieldType.Multiple : NbFieldType.Massive;
  }

  _items: Array<NbMassiveItem> = [];
  @Input()
  set options(val) {
    // console.log('opts:',val);
    if (val) {
      this._items = val;
      if (!!this._data && this._data.length > 0) {
        this.setSelected();
      }
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }
  _data: any;
  get data(): any {
    return this._data;
  };
  @Input()
  set data(val: any) {
    this._selectedTexts = [];
    if (val != null && val != undefined) {
      if (this.multiple && (typeof val === 'string' || !Array.isArray(val))) {
        this._data = [val];
      } else {
        this._data = val;
      }
      if (!!this._items && this._items.length > 0) {
        this.setSelected();
      }
      this.onChangeCallback(this._data);
    } else {
      this._data = null;
    }
  }
  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }

  _selectedCss: string[] = [];
  _selectedTexts: string[] = [];
  setSelected() {
    this._selectedTexts = [];
    if (this.multiple) {
      this._data.forEach(d => {
        const item = this._items.find(f => f.value == d);
        if (item) {
          this._selectedTexts.push(item.text);
          let selc = '';
          if (item.css) {
              if (typeof item.css == 'string') {
                  selc = item.css;
              } else if (typeof item.css == 'object' && typeof item.css.length == 'number') {
                  selc = item.css.join(' ');
              }
          }
          this._selectedCss.push(selc);
        }
      });
    } else {
      const item = this._items.find(f => f.value == this._data);
      if (item) {
        this._selectedTexts.push(item.text);
          let selc = '';
          if (item.css) {
              if (typeof item.css == 'string') {
                  selc = item.css;
              } else if (typeof item.css == 'object' && typeof item.css.length == 'number') {
                  selc = item.css.join(' ');
              }
          }
          this._selectedCss.push(selc);
      }
    }
  }

  @Input()
  readonly = false;

  @Input()
  placeholder = '';

  disabled = false;
  registerOnChange(fn: any): void {if (fn) { this.onChangeCallback = fn; }}
  registerOnTouched(fn: any): void {if (fn) { this.onTouchedCallback = fn; }}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled; }
  writeValue(obj: any ): void {
    this.value = obj;
  }

  @Output()
  public onAdded: EventEmitter<any> = new EventEmitter();
  added(e) {
    // console.log('added: ',e);
    this.onAdded.emit(e.value);
  }
  @Output()
  public onRemoved: EventEmitter<any> = new EventEmitter();
  removed(e) {
    // console.log('removed: ',e);
    this.onRemoved.emit(e.value);
  }
  @Output()
  public onCleared: EventEmitter<any> = new EventEmitter();
    cleared(e) {
    this.onCleared.emit(e.value);
  }
  @Output()
  public onChange: EventEmitter<any> = new EventEmitter();
  changed(e) {
    // console.log('changed: ',e);
    if (Array.isArray(e)) {
      // console.log('isarr');
      this.onChange.emit(e.map(s => s.value));
      this.onChangeCallback(e.map(s => s.value));
    } else {
      this.onChange.emit(e ? e.value : null);
      this.onChangeCallback(e ? e.value : null);
    }
  }
}
